module.exports = __webpack_public_path__ + "static/media/tabungan_siswa.9ab9a3cd.png";